<app-navbar />

<main id="main-content">
  <section class="page-hero">
    <div class="container">
      <app-breadcrumb [trail]="[{ label: 'FAQ' }]" />
      <span class="eyebrow">Frequently asked questions</span>
      <h1>Everything you want to know about deceased verification</h1>
      <p>
        Clear answers about how the service works, where the data comes from, what it costs and how
        we keep your data safe. Still have a question? Our team is glad to help.
      </p>
    </div>
  </section>

  <section class="section">
    <div class="container">
      <div class="faq-layout">
        <aside class="faq-nav">
          <p class="faq-nav-label">Browse by topic</p>
          <ul>
            @for (group of groups; track group.title) {
              <li>
                <a [routerLink]="[]" [fragment]="slug(group.title)">{{ group.title }}</a>
              </li>
            }
          </ul>
          <div class="faq-nav-card">
            <p class="faq-nav-card-title">Need a hand?</p>
            <p class="faq-nav-card-text">Talk to our team and get answers tailored to your use case.</p>
            <a class="btn btn-primary btn-block" [routerLink]="[routes.contact.url]">Contact us</a>
          </div>
        </aside>

        <div class="faq-content">
          @for (group of groups; track group.title) {
            <div class="faq-group" [id]="slug(group.title)">
              <h2 class="faq-group-title">{{ group.title }}</h2>
              <div class="faq-list">
                @for (faq of group.faqs; track faq.question) {
                  <details class="faq-item">
                    <summary>{{ faq.question }}</summary>
                    <p>{{ faq.answer }}</p>
                  </details>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </section>

  <section class="section section-alt">
    <div class="container">
      <div class="cta-band">
        <h2>Still have questions?</h2>
        <p>Reach out and we will walk you through the data, the API and pricing for your team.</p>
        <div class="actions-row center">
          <a class="btn btn-primary btn-lg" [routerLink]="[routes.contact.url]">Contact us</a>
          <a class="btn btn-outline btn-lg" [routerLink]="[routes.howItWorks.url]">See how it works</a>
        </div>
      </div>
    </div>
  </section>
</main>

<app-footer />
